import { render } from "./Support_Chat_Widget.vue?vue&type=template&id=60abfa16&scoped=true"
import script from "./Support_Chat_Widget.vue?vue&type=script&lang=js"
export * from "./Support_Chat_Widget.vue?vue&type=script&lang=js"

import "./Support_Chat_Widget.vue?vue&type=style&index=0&id=60abfa16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60abfa16"]])

export default __exports__